const desktop = theme => {
  const {toVW} = theme;

  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    '@keyframes neonLight': {
      '0%': {
        boxShadow: '0 0 5px white, 0 0 5px white, 0 0 5px white, 0 0 5px white',
      },
      '50%': {
        boxShadow: '0 0 0px white',
      },
      '100%': {
        boxShadow: '0 0 5px white, 0 0 5px white, 0 0 5px white, 0 0 5px white',
      },
    },
    flashingBorder: {
      position: 'absolute',
      zIndex: 'auto',
      borderRadius: 5,
      width: '100%',
      height: '100%',
      animation: '$neonLight 1.5s step-end infinite',
    },
    timerLayer: {
      position: 'absolute',
      zIndex: 2,
      height: '100%',
      mixBlendMode: 'overlay',
      borderRadius: 5,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
